class QuickAdd {
  constructor() {
    this.modal = null;
    this.contentContainer = null;
    this.loadingElement = null;
    this.titleElement = null;
    this.init();
    this.observeDOM();
  }

  init() {
    this.modal = document.getElementById('quick-view-modal');
    if (this.modal) {
      this.contentContainer = this.modal.querySelector('.quick-view-modal__product-info');
      this.loadingElement = this.modal.querySelector('.quick-view-modal__loading');
      this.titleElement = this.modal.querySelector('.modal-window-title');
    }

    document.querySelectorAll('[data-quick-add-button]:not([data-quick-add-init])').forEach((button) => {
      button.setAttribute('data-quick-add-init', 'true');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleClick(button);
      });
    });
  }

  observeDOM() {
    const observer = new MutationObserver(() => this.init());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  handleClick(button) {
    const hasVariants = button.getAttribute('data-has-variants') === 'true';
    const variantId = button.getAttribute('data-variant-id');

    if (hasVariants) {
      const productId = button.getAttribute('data-product-id');
      const productTitle = button.getAttribute('data-product-title');
      this.openModal(productId, productTitle);
    } else {
      this.addToCart(variantId, button);
    }
  }

  addToCart(variantId, button, quantity = 1) {
    if (!variantId) return;

    if (button) button.classList.add('loading');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          console.error('Error adding to cart:', data.description);
          return;
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: data,
          })
        );

        // Close modal after successful add
        if (window.modalHandler) {
          window.modalHandler.closeCurrentModal();
        }
      })
      .catch((error) => {
        console.error('Add to cart error:', error);
      })
      .finally(() => {
        if (button) button.classList.remove('loading');
      });
  }

  openModal(productId, productTitle) {
    // Re-query modal (may have been moved to body)
    this.modal = document.getElementById('quick-view-modal');
    if (this.modal) {
      this.contentContainer = this.modal.querySelector('.quick-view-modal__product-info');
      this.titleElement = this.modal.querySelector('.modal-window-title');
    }

    if (!this.modal || !window.modalHandler) {
      console.error('Quick view modal not found');
      return;
    }

    // Find quick-add data for this product
    const quickAddData = document.querySelector(`[data-quick-add-data][data-product-id="${productId}"]`);
    if (!quickAddData) {
      console.error('Quick add data not found for product:', productId);
      return;
    }

    // Set title
    if (this.titleElement) {
      this.titleElement.textContent = productTitle || '';
    }

    // Move content into modal
    if (this.contentContainer) {
      this.contentContainer.innerHTML = '';
      // Clone the inner content
      this.contentContainer.innerHTML = quickAddData.innerHTML;

      // Attach submit handler to form (custom elements don't reinitialize with innerHTML)
      const form = this.contentContainer.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        form.addEventListener('submit', (e) => this.handleModalFormSubmit(e));
      }
    }

    // Hide loading (not needed)
    if (this.loadingElement) {
      this.loadingElement.style.display = 'none';
    }

    // Open modal
    window.modalHandler.showModal('quick-view-modal');
  }

  handleModalFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) return;

    const variantId = variantInput.value;
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (submitButton) {
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', 'true');
    }

    this.addToCart(variantId, submitButton, quantity);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.quickAdd = new QuickAdd();
});
